define([
   'WebCommon/event-bus',
    'WebCommon/events'
], function(
    EventBus,
    Events
){
    return {
        data: function(){
            return {
                isPageReady: false
            };
        },
        mounted: function(){
            var _this = this;
            EventBus.$on(Events.PageReady, function(){
                _this.isPageReady = true;
            });
        },
        destroy: function(){
            EventBus.$off(Events.PageReady);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/mixin/page-ready.js
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 8